import React from "react";
import "../styles/BillingToggle.css";

/**
 * Monthly / Annual. Real buttons with aria-pressed, so assistive technology
 * hears which is chosen. `savePercent` is worked out from the plans' prices by
 * the caller; the badge is left out when there is none.
 */
const BillingToggle = ({ value, onChange, savePercent }) => (
  <div className="billing-toggle" role="group" aria-label="Billing period">
    <button
      type="button"
      className="billing-option"
      aria-pressed={value === "monthly"}
      onClick={() => onChange("monthly")}
    >
      Monthly
    </button>
    <button
      type="button"
      className="billing-option"
      aria-pressed={value === "annual"}
      onClick={() => onChange("annual")}
    >
      Annual
      {savePercent ? <span className="save-badge">Save up to {savePercent}%</span> : null}
    </button>
  </div>
);

export default BillingToggle;
